import apiClient from '../config/api';

const areaService = {
  getAllAreas: async () => {
    // Controller is AreaController -> /api/area
    const response = await apiClient.get('/area');
    return response.data;
  },

  getAreaById: async (id) => {
    const response = await apiClient.get(`/area/${id}`);
    return response.data;
  },

  createArea: async (data) => {
    const response = await apiClient.post('/area', data);
    return response.data;
  },

  updateArea: async (id, data) => {
    const response = await apiClient.post(`/area/update/${id}`, data);
    return response.data;
  },

  deleteArea: async (id) => {
    const response = await apiClient.post(`/area/delete/${id}`);
    return response.data;
  }
};

export default areaService;
